// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Комітети ВРУ» (Committees of the Verkhovna Rada, ключ `radacmt`, група `committees`). */
export const committeesOfTheVerkhovnaRadaManifest: IModuleManifest = {
  key: 'radacmt',
  group: 'committees',
  slug: 'committees-of-the-verkhovna-rada',
  prefix: 'KOM',
  name: { en: 'Committees of the Verkhovna Rada', uk: 'Комітети ВРУ' },
  entities: [
    { key: 'radacmt', slug: 'radacmt', name: { en: 'Committees', uk: 'Комітети' }, main: true },
    { key: 'cmtmem', slug: 'cmtmem', name: { en: 'Committee members', uk: 'Члени комітетів' }, main: false },
    { key: 'subcmt', slug: 'subcmt', name: { en: 'Subcommittees', uk: 'Підкомітети' }, main: false },
  ],
  loadState: () => import('./state/committeesOfTheVerkhovnaRadaSlice').then((m) => m.committeesOfTheVerkhovnaRadaSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
